import React from 'react'
import _cx from 'classnames/bind'
// @ts-ignore no types
import _ from 'lodash'
// @ts-ignore no types
import { connect } from 'react-redux'
// @ts-ignore no types
import { TutorialTooltip } from '@adc/ui-adc'
import type {
  Listing,
  CollateralAnalyticsProperty,
  CollateralAnalyticsData,
  CollateralAnalyticsPropertyInfo,
  CollateralAnalyticsNeighborhoodView,
  CollateralAnalyticsPublicSchools,
  Maybe,
} from '@adc/sdk/types'
import ValuationDetails from './valuationDetails'
// @ts-ignore no types
import cls from './index.scss'

interface RealtyTrackReport extends CollateralAnalyticsData {
  comps: CollateralAnalyticsData['comparables']
  data: CollateralAnalyticsData
  rentals: CollateralAnalyticsPropertyInfo['propertylistArray']
  taxInfo: CollateralAnalyticsProperty['info']
  schools: CollateralAnalyticsPublicSchools['school']
  neighborhood: CollateralAnalyticsNeighborhoodView['areaanalysis']
  highlights: CollateralAnalyticsNeighborhoodView['communityfeatures']
  // this should be computed
  isAnalysisDataAvailable: boolean
  saleHistory: CollateralAnalyticsProperty['historicaltransactions']
  rentalRange: Maybe<{
    low: number
    high: number
    median: number
    estimated: number
  }>
  hidePIR: boolean
}
interface InvestmentInfoProps {
  buyerViews?: number
  listing: Listing
  featureFlags?: any
  showRentalEstimate?: boolean
  realtyTrackReport?: RealtyTrackReport
  isPropertyReportAvailable?: boolean
}

const InvestmentInfo = ({
  buyerViews = 0,
  featureFlags,
  showRentalEstimate,
  isPropertyReportAvailable,
  realtyTrackReport,
}: InvestmentInfoProps) => {
  return (
    <div id='investment_info' data-elm-id='investment_info'>
      <TutorialTooltip
        elmId='valuation_details_tutorial_tooltip'
        tutorial={2}
        header='Discover Profit Potential'
        position='left center'
        mobilePosition='top center'
        content='Learn about the potential return on this property.'
      >
        <ValuationDetails
          buyerViews={buyerViews}
          showRentalEstimate={showRentalEstimate}
          featureFlags={featureFlags}
          realtyTrackReport={realtyTrackReport}
          isPropertyReportAvailable={isPropertyReportAvailable}
        />
      </TutorialTooltip>
    </div>
  )
}

const mapStateToProps = (store: any) => ({
  buyerViews: store.propertyAnalytics.propertyViews,
  featureFlags: store.featureFlags,
  realtyTrackReport: store.propertyAnalytics.realtyTrackReport,
  listing: store.listing,
  showRentalEstimate:
    store.propertyAnalytics.isPropertyReportAvailable &&
    store?.listing?.listing_configuration?.is_rental_estimate_hidden === false,
  isPropertyReportAvailable: store.propertyAnalytics.isPropertyReportAvailable,
})

export default connect<ReturnType<typeof mapStateToProps>>(mapStateToProps)(
  InvestmentInfo
)
